import { path, pipe, prop, reject } from 'ramda';
import download from 'downloadjs';
import {
  FETCH_GIFT_CARDS,
  FETCH_GIFT_CARDS_SUCCESS,
  FETCH_GIFT_CARD_SUMMARY,
  SET_SOLD_GIFT_CARDS,
  RESET_SOLD_GIFT_CARDS,
  DELETE_GIFT_CARD,
  ADD_GIFT_CARD,
} from './constants';
import Http from '../../http';


const fetchGiftCardsAction = () => ({ type: FETCH_GIFT_CARDS });
const fetchGiftCardsSuccessAction = payload => ({ type: FETCH_GIFT_CARDS_SUCCESS, payload });

const limit = 50;

export const fetchGiftCards = shopId => async (dispatch) => {
  dispatch(fetchGiftCardsAction());
  let skip = 0;
  let shouldFetch = true;
  while (shouldFetch) {
    const res = await Http.get(`/shop/${shopId}/gift-card`, { limit, skip });
    const giftCards = res.rows;
    shouldFetch = giftCards.length >= limit;
    skip += limit;

    pipe(
      prop('rows'),
      reject(prop('deletedAt')),
      fetchGiftCardsSuccessAction,
      dispatch,
    )(res);
  }

  return true;
};

const fetchGiftCardSummaryAction = payload => ({
  type: FETCH_GIFT_CARD_SUMMARY,
  payload,
});

export const fetchGiftCardSummary = shopId => dispatch =>
  Http.get(`/shop/${shopId}/gift-card/?view=summary`)
    .then(pipe(fetchGiftCardSummaryAction, dispatch));

export const searchGiftCard = (shopId, keyword) =>
  Http.get(`/shop/${shopId}/gift-card/?code__like=${keyword}`)
    .then(path(['rows', 0]));

export const fetchGiftCardByCode = (shopId, code) =>
  Http.get(`/shop/${shopId}/gift-card/?code=${code}`)
    .then(path(['rows', 0]));

const deleteGiftCardAction = giftCardId => ({
  type: DELETE_GIFT_CARD,
  payload: giftCardId,
});

export const deleteGiftCard = (shopId, giftCardId) => dispatch =>
  Http.delete(`/shop/${shopId}/gift-card/${giftCardId}`)
    .then(() => dispatch(deleteGiftCardAction(giftCardId)));

export const downloadGiftCardCsv = shopId =>
  Http.getRaw(`/shop/${shopId}/gift-card/?view=csv`)
    .then(response => download(response, 'gift-cards.csv', 'text/plain'));

const addGiftCardAction = giftCard => ({
  type: ADD_GIFT_CARD,
  payload: giftCard,
});

export const addCustomGiftCard = (shopId, { initialBalance, code, status = 'paid' }) => dispatch => (
  Http.post(`/shop/${shopId}/custom-gift-card`, { initialBalance, code, status })
    .then(giftCard => dispatch(addGiftCardAction(giftCard)))
);

export const setSoldGiftCards = giftCards => ({
  type: SET_SOLD_GIFT_CARDS,
  payload: giftCards,
});

export const resetSoldGiftCards = () => ({
  type: RESET_SOLD_GIFT_CARDS,
});
